<div class="app-preview-header bc-work-item-theme {{ getThemeClass() }}">
  <header class="header row-flex-container">
    <app-avatar [workItemId]="workItemId" [workItemType]="workItemType"></app-avatar>

    <ng-container *ngIf="(visitor$ | async) as visitor; else loading">
      <div class="visitor-name" title="{{ visitor.displayName }}">
        <span class="visitor-name-text">{{ visitor.displayName }}</span>
      </div>
    </ng-container>
    <ng-template #loading>
      <div class="visitor-name"></div>
    </ng-template>

    <app-work-item-preview-lane-buttons *ngIf="!isEmail" class="row-flex-fix"></app-work-item-preview-lane-buttons>

    <div class="tools row-flex-fix">
      <svg-icon class="tools-icon tools-minimize js-close-lane" icon="x" (click)="closeLane()"></svg-icon>
    </div>
  </header>
</div>
